import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from 'projects/admin/src/app/layout/service/app.layout.service';
import { AppService } from '../core/services/app.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent {

    constructor(
        public layoutService: LayoutService,
        public appService: AppService,
        public router: Router
    ) { }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();
    }

    customStyle = {
        width: "2rem",
        height: "2rem",
        lineHeight: "2rem",
        fontSize: "1rem"
    }
    
}